import { useRiskOverviewResponse } from "./useRiskOverviewResponse";

export function useRoleScoreList() {
  const { riskScore } = useRiskOverviewResponse();

  return {
    riskScore,
  };
}
